import React from 'react';
import { Modal } from 'react-bootstrap';

const SubsMainModal = ({ isVisible, setIsVisible, packageType, subscriptionNo, subscriptionName, duration, frequency, productCategory, products, productQuantity, facialScans, addonFacialScans, amount, subscriptionCreatedDate, subscriptionStartDate, subscriptionEndDate, status }) => {
  return (
    <Modal show={isVisible} size='lg' onHide={() => setIsVisible(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Subscription Details</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '20px' }}>
        {/* Using Flexbox for Horizontal Layout */}
        <div className='row  '>
          <div className='col-lg-6'>Package Type</div>
          <div className='col-lg-6 text-right'>{packageType}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Subscription No.</div>
          <div className='col-lg-6 text-right'>{subscriptionNo}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Subscription Name</div>
          <div className='col-lg-6 text-right'>{subscriptionName}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Duration</div>
          <div className='col-lg-6 text-right'>{duration}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Frequency</div>
          <div className='col-lg-6 text-right'>{frequency}</div>
        </div>
        {/* <div className='row  pt-3'>
          <div className='col-lg-6'>Product Category</div>
          <div className='col-lg-6 text-right'>{productCategory}</div>
        </div> */}
        <div className='row  pt-3'>
          <div className='col-lg-6'>Products</div>
          <div className='col-lg-6 text-right'>{products}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Product Quantity per Frequency</div>
          <div className='col-lg-6 text-right'>{productQuantity}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Facial Scans</div>
          <div className='col-lg-6 text-right'>{facialScans}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Addon Facial Scans</div>
          <div className='col-lg-6 text-right'>{addonFacialScans}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Amount</div>
          <div className='col-lg-6 text-right'>{amount}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Subscription Created Date</div>
          <div className='col-lg-6 text-right'>{subscriptionCreatedDate}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Subscription Start Date</div>
          <div className='col-lg-6 text-right'>{subscriptionStartDate}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Subscription End Date</div>
          <div className='col-lg-6 text-right'>{subscriptionEndDate}</div>
        </div>
        <div className='row  pt-3'>
          <div className='col-lg-6'>Status</div>
          <div className='col-lg-6 text-right'>{status}</div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className='btn btn-primary' onClick={() => setIsVisible(false)}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubsMainModal;
